import { examConstants } from '../../constants';

const initialExamsState = {
  examsList: [] as any[],
  currentExam: null as any,
  pagination: {
    page: 1,
    limit: 12,
    total: 0,
    totalPages: 0,
  },
  loading: false,
  error: null as any,
};

export function exams(state = initialExamsState, action: any) {
  switch (action.type) {
    case examConstants.GETALL_REQUEST:
      return { ...state, loading: true };
    case examConstants.GETALL_SUCCESS:
      // Handle response with data and pagination
      return { 
        ...state, 
        examsList: action.payload.data || [], 
        pagination: action.payload.pagination || state.pagination,
        loading: false 
      };
    case examConstants.GETALL_FAILURE:
      return { ...state, error: action.payload, loading: false };
    
    case examConstants.GETBYID_REQUEST:
      return { ...state, loading: true };
    case examConstants.GETBYID_SUCCESS:
      return { 
        ...state, 
        currentExam: action.payload.data || action.payload,
        loading: false 
      };
    case examConstants.GETBYID_FAILURE:
      return { ...state, error: action.payload, loading: false };
    
    case examConstants.CREATE_SUCCESS:
      return { 
        ...state,
        examsList: [action.payload.data || action.payload, ...state.examsList]
      };
    
    case examConstants.DELETE_SUCCESS:
      return { 
        ...state, 
        examsList: state.examsList.filter(exam => exam.id !== action.payload)
      };
    
    case examConstants.UPDATE_SUCCESS:
      const updatedExam = action.payload.data || action.payload;
      return { 
        ...state, 
        examsList: state.examsList.map(exam =>
          exam.id === updatedExam.id ? updatedExam : exam
        ),
        currentExam: state.currentExam?.id === updatedExam.id ? updatedExam : state.currentExam,
      };
    
    case examConstants.DUPLICATE_SUCCESS:
      return { 
        ...state,
        examsList: [action.payload.data || action.payload, ...state.examsList]
      };
    
    default:
      return state;
  }
}
